import { useCallback, useEffect, useReducer, useState } from 'react';
import { formatInTimeZone } from 'date-fns-tz';
import cn from 'classnames';
import cloneDeep from 'lodash/cloneDeep';
import s from './Schedule.module.scss';
import Filter from './Filter';
import ScheduleItem from './ScheduleItem';

const defaultState = {
  search: '',
  genre: '',
  tag: '',
  location: '',
};

function reducer(_state, action) {
  if (action.type === 'CLEAR') {
    return { ...defaultState };
  }

  return {
    ...defaultState,
    [action.type]: action.payload,
  };
}

function filterSchedule(schedule, state) {
  const newSchedule = cloneDeep(schedule);

  newSchedule.tabs.forEach((tab, tabIndex) => {
    newSchedule.tabs[tabIndex].items = tab.items.filter((item) => {
      if (state.search) {
        const searchTerm = state.search.toLowerCase();
        const searchString = `${item.title}${item.description}`.toLowerCase();
        return searchString.indexOf(searchTerm) > -1;
      }

      if (state.genre) {
        return item.genres.includes(state.genre);
      }

      if (state.tag) {
        return item.tags.includes(state.tag);
      }

      if (state.location) {
        return item.location === state.location;
      }

      return true;
    });
  });

  return {
    ...newSchedule,
    tabs: newSchedule.tabs.filter((tab) => tab.items.length > 0),
  };
}

export default function Schedule(props) {
  const { schedule, guest, showSidebar } = props;

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [filteredSchedule, setFilteredSchedule] = useState(schedule);
  const [state, dispatch] = useReducer(reducer, defaultState);

  const handleFilterSchedule = useCallback((type, payload) => {
    dispatch({ type, payload });

    const el = document.getElementById('fp-schedule');
    const top = el.offsetParent.offsetTop - 70;
    window.scrollTo({ top, behavior: 'smooth' });
  }, []);

  const handleClearFilters = useCallback(() => {
    dispatch({ type: 'CLEAR' });
  }, []);

  useEffect(() => {
    setFilteredSchedule(filterSchedule(schedule, state));
  }, [schedule, state]);

  return (
    <div className={s.wrapper} id="fp-schedule">
      <div className={s.content}>
        <div className={s.tabs}>
          {filteredSchedule.tabs.map((tab, index) => (
            <div
              key={index}
              onClick={() => setActiveTabIndex(index)}
              className={cn(s.tab, {
                [s.tabActive]: activeTabIndex === index,
              })}
              role="button"
            >
              {formatInTimeZone(new Date(tab.date), 'UTC', 'eeee MMM dd, yyyy')}
            </div>
          ))}
        </div>
        <div className={s.schedule}>
          {filteredSchedule.tabs.length === 0 ? (
            <p>No Results Found</p>
          ) : (
            filteredSchedule.tabs[activeTabIndex]?.items.map((item, index) => (
              <div
                key={`${activeTabIndex}-${index}`}
                className={s.scheduleItem}
              >
                <ScheduleItem data={item} guest={guest} />
              </div>
            ))
          )}
        </div>
      </div>
      {showSidebar && (
        <div className={s.aside}>
          <Filter
            schedule={schedule}
            state={state}
            onFilter={handleFilterSchedule}
            onClear={handleClearFilters}
          />
        </div>
      )}
    </div>
  );
}
